// App IMPORTANT for importing styling
import './mainscripts.js'

import Vue from 'vue'
// bootstrap
import 'bootstrap'

//
// COMPONENTS
//
// session-component (global for all pages where the user is logged in)
import Session from './components/session/endSession.vue'
Vue.component('session-component', Session)

// polis-component (polisoverzicht)
import Polis from './components/polis.vue'
Vue.component('polis-component', Polis)

// polisnonvsp-component (mijn overzicht) =. only shows very basic info in small
// block
import PolisNonVSP from './components/polisnonvsp.vue'
Vue.component('polisnonvsp-component', PolisNonVSP)

// produkt-component (polisoverzicht)
import Produkt from './components/produkt.vue'
Vue.component('produkt-component', Produkt)

// accountgegevens (mijn gegevens)
import Accountgegevens from './components/mijngegevens/accountgegevens.vue'
Vue.component('accountgegevens-component', Accountgegevens)

// betaalgegevens (mijn gegevens)
import Betaalgegevens from './components/mijngegevens/betaalgegevens.vue'
Vue.component('betaalgegevens-component', Betaalgegevens)

// contactgegevens (mijn gegevens)
import Contactgegevens from './components/mijngegevens/contactgegevens.vue'
Vue.component('contactgegevens-component', Contactgegevens)

// persoonsgegevens (mijn gegevens)
import Persoonsgegevens from './components/mijngegevens/persoonsgegevens.vue'
Vue.component('persoonsgegevens-component', Persoonsgegevens)

// polisdetails-produkt (polisdetails)
import PolisdetailsProdukt from './components/polisdetails/produkt.vue'
Vue.component('polisdetails-produkt', PolisdetailsProdukt)

// polisdetails-premie (polisdetails)
import PolisdetailsPremie from './components/polisdetails/premie.vue'
Vue.component('polisdetails-premie', PolisdetailsPremie)

// polisdetails-verzekering (polisdetails)
import PolisdetailsVerzekering from './components/polisdetails/verzekering.vue'
Vue.component('polisdetails-verzekering', PolisdetailsVerzekering)

// polisdetails-dekking (polisdetails)
import PolisdetailsDekking from './components/polisdetails/dekking.vue'
Vue.component('polisdetails-dekking', PolisdetailsDekking)

// polisdetails-directlinks (polisdetails)
import PolisdetailsDirectLinks from './components/polisdetails/directlinks.vue'
Vue.component('polisdetails-directlinks', PolisdetailsDirectLinks)

// polisdetails-inbehandeling (polisdetails)
import InBehandeling from './components/polisdetails/inbehandeling.vue'
Vue.component('polisdetails-inbehandeling', InBehandeling)

// polisdetails-gkaangevraagd (polisdetails)
import GKAangevraagd from './components/polisdetails/gkaangevraagd.vue'
Vue.component('polisdetails-gkaangevraagd', GKAangevraagd)

// schadeproces-component (mijn schades)
import Schadeproces from './components/schade/schadeproces.vue'
Vue.component('schadeproces-component', Schadeproces)

// faq-component (service en contact, login, mijn schades)
import Faq from './components/faqs.vue'
Vue.component('faq-component', Faq)

// facturen-component (mijnfacturen)
import Facturen from './components/facturen.vue'
Vue.component('facturen-component', Facturen)

// mijnschades-component (mijnschades)
import Mijnschades from './components/schade/mijnschades.vue'
Vue.component('mijnschades-component', Mijnschades)
// schadestatus-component (mijnoverzicht)
import SchadeStatus from './components/schade/schadestatus.vue'
Vue.component('schadestatus-component', SchadeStatus)

// loader-component (service en contact)
import Loader from './components/loader.vue'
Vue.component('loader-component', Loader)

// berichten-component (service en contact)
import Berichten from './components/berichten/berichten.vue'
Vue.component('berichten-component', Berichten)

// berichten-component (overzicht)
import BerichtOngelezenKnop from './components/berichten/bericht-ongelezenknop.vue'
Vue.component('berichtongelezenknop-component', BerichtOngelezenKnop)

// logo werkgever (overzicht)
import LogoWerkgever from './components/logo-werkgever.vue'
Vue.component('logowerkgever-component', LogoWerkgever)

// banner-component (all pages)
import Banner from './components/banner.vue'
Vue.component('banner-component', Banner)

// polisdetails-documenten (polisdetails) // NOT USED
// import PolisdetailsDocumenten from './components/polisdetails-documenten.vue'
// Vue.component('polisdetails-documenten', PolisdetailsDocumenten)

// berichten-component (berichten-component) // ONLY USED AS CHILD OF
// BERICHTEN.VUE
// import Bericht from './components/bericht.vue'
// Vue.component('bericht-component', Bericht)

// paging-component (berichten-comp, facturen-comp)
// import Paging from './components/paging.vue'
// Vue.component('paging-component', Paging)

//
// DIRECTIVES
//
// import './directives/show-produkten'

// include vue components when an element with the id="vue" exists
var vm = new Vue({
  el: '#vue',
  methods: {
	  resizeIframe: function(frame){
			var curHeight =  $(frame).contents().find('body').height() + 75;
			$(frame).css('height', curHeight + 'px' );
	  },
	  setIframeUrl : function(iframeSelector, serviceMethod) {
			$.getJSON("services/urlservice/" + serviceMethod, function( data ) {
				if(data != null) {
					$(iframeSelector).prop('src', data.url);
				}
			});
	  }
  }
});


global.vm = vm;



// WEBPACK FOOTER //
// ./src/main/frontend/main.js